// extracted by mini-css-extract-plugin
export default {"Toys":"Toys_Toys__mTKoB","Small":"Toys_Small__YR-g9"};